import * as React from "react";
const ArrowUp = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.14453 15.853C2.95033 15.6567 2.95205 15.3401 3.14838 15.1459L10.9451 7.4336C11.5296 6.85549 12.4704 6.85549 13.0549 7.4336L20.8516 15.1459C21.0479 15.3401 21.0497 15.6567 20.8555 15.853C20.6613 16.0493 20.3447 16.0511 20.1484 15.8569L12.3516 8.14454C12.1568 7.95184 11.8432 7.95184 11.6484 8.14454L3.85162 15.8569C3.6553 16.0511 3.33872 16.0493 3.14453 15.853Z"
            fill="red"
        />
    </svg>
);
export default ArrowUp;
